export default {
  title: 'Geographical Point',
  name: 'geopoint',
  type: 'object',
  fields: [
    {
      name: 'lat',
      type: 'number',
      title: 'Latitude',
    },
    {
      name: 'lng',
      type: 'number',
      title: 'Longitude',
    },
    {
      name: 'alt',
      type: 'number',
      title: 'Altitude',
    },
  ],
}
